import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_HOMEPAGE = "SHOP:DELETE_HOMEPAGE";

export const deleteHomepageAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: DELETE_HOMEPAGE as typeof DELETE_HOMEPAGE,
  organization,
  id,
});

export type DeleteHomepageAction = ReturnType<typeof deleteHomepageAction>;
